import { render, staticRenderFns } from "./FasesContrato.vue?vue&type=template&id=cc076258&"
import script from "./FasesContrato.vue?vue&type=script&lang=js&"
export * from "./FasesContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports